import React, { createContext, useContext } from 'react'

const HeaderContext = createContext()

export const useHeader = () => {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider')
  }
  return context
}

export const HeaderProvider = ({ children, isVisible, setIsVisible }) => {
  return (
    <HeaderContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </HeaderContext.Provider>
  )
}
